import * as React from "react";
import { ITeamRole } from "../../vm";
import {
  IStackTokens,
  Stack,
  TextField,
  Toggle,
  DefaultButton,
  PrimaryButton,
  Dropdown,
  TagPicker,
  ITag,
  IBasePickerSuggestionsProps,
  Label,
  Text,
} from "office-ui-fabric-react";
import CustomDrawer from "../common/CustomDrawer";
import { Formik, FormikErrors } from "formik";
import { EMAIL_REGEX, INFRASTRUCTURE_TAGS } from "../common/Constants";
import {
  addShiftManager,
  updateShiftManager,
} from "../../services/shiftOperator/ShiftManagerService";
import { isValidPassword } from "../../services/UtilService";
import PasswordPolicy from "../common/PasswordPolicy";
import { ToastContext } from "../common/ToastProvider";

export interface ManageShiftManagerProps {
  data?: ITeamRole;
  closeManageDialog: any;
  handleLoading: any;
  datacenterId: string;
  datacenters: ITag[];
}

const ManageShiftManager: React.FC<ManageShiftManagerProps> = ({
  data,
  closeManageDialog,
  handleLoading,
  datacenterId,
  datacenters
}) => {
  const [state, setState] = React.useState({
    shiftManager: {
      name: "",
      email: "",
      password: "",
      isEnabled: true,
      isDeleted: false,
      role: undefined,
      units: [],
      datacenterId: datacenterId,
      datacenterIds: [datacenterId],
      ...data,
    },
    isLoading: false,
    defTags: [],
  } as {
    shiftManager: ITeamRole;
    isLoading: boolean;
    defTags: ITag[];
  });

  const closeAddDialog = (data?: ITeamRole) => {
    closeManageDialog(data);
  };

  const { showToast } = React.useContext(ToastContext);
  const wrapStackTokens: IStackTokens = { childrenGap: 16 };

  const dropDownOptions = [
    { key: 0, text: "Shift Manager" },
    { key: 1, text: "Shift Operator" },
  ];

  // const dropdownStyles: Partial<IDropdownStyles> = { dropdown: { width: 300 } };

  const testTags: ITag[] = INFRASTRUCTURE_TAGS;

  const getTextFromItem = (item: ITag) => item.name;

  const listContainsTagList = (tag: ITag, tagList?: ITag[]) => {
    if (!tagList || !tagList.length || tagList.length === 0) {
      return false;
    }
    return tagList.some((compareTag) => compareTag.key === tag.key);
  };

  const filterSuggestedTags = (filterText: string, tagList: ITag[]): ITag[] => {
    return filterText
      ? testTags.filter(
          (tag) =>
            tag.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0 &&
            !listContainsTagList(tag, tagList)
        )
      : [];
  };

  const filterSuggestedTagsForDC = (filterText: string, tagList: ITag[]): ITag[] => {
    let allDataCenterList = [...datacenters];

    return filterText
      ? allDataCenterList.filter(
          (tag) =>
            tag.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0 &&
            !listContainsTagList(tag, tagList)
        )
      : [];
  };

  const pickerSuggestionsProps: IBasePickerSuggestionsProps = {
    // suggestionsHeaderText: "Suggested Units",
    // mostRecentlyUsedHeaderText: "Suggested Units",
    noResultsFoundText: "No unit tags found",
  };

  const pickerSuggestionsPropsForDC: IBasePickerSuggestionsProps = {
    noResultsFoundText: "No datacenter found",
  };

  const showAllTags = (selectedItems?: ITag[] | undefined) => {
    return removeDuplicates(INFRASTRUCTURE_TAGS, selectedItems);
  };

  const showAllTagsForDC = (selectedItems?: ITag[] | undefined) => {
    let allDataCenterList = [...datacenters];
    return removeDuplicates(allDataCenterList, selectedItems);
  };

  function removeDuplicates(tagList: ITag[], tags?: ITag[]) {
    return tagList.filter((tag) => !listContainsTagList(tag, tags));
  }

  React.useEffect(() => {
    console.log("state", state.shiftManager);
    if (data && data.units.length > 0) {
      let tag: any = data.units.map((unit) => {
        return INFRASTRUCTURE_TAGS.find((ele) => ele.key === unit);
      });
      setState({ ...state, defTags: tag });
      console.log("units_tags", tag);
    }
  }, []);

  return (
    <React.Fragment>
      <CustomDrawer
        title={
          state.shiftManager._id
            ? `Update Shift ${data?.role === 0 ? "Manager" : "Operator"}`
            : "Add Shift Manager/Operator"
        }
        handelOpen={true}
        onClose={() => closeAddDialog()}
      >
        <Stack>
          <Formik
            enableReinitialize
            initialValues={state.shiftManager}
            validate={(values: any) => {
              let errors: FormikErrors<ITeamRole> = {};
              if (!values.name) {
                errors.name = "Required";
              }
              if (!values._id && !values.password) {
                errors.password = "Required";
              }
              if (
                !values._id &&
                values.password &&
                !isValidPassword(values.password, false)
              ) {
                errors.password = "Please enter valid password.";
              }
              if (!values.email) {
                errors.email = "Required";
              }
              if (values.email && !EMAIL_REGEX.test(values.email)) {
                errors.email = "Invalid email address";
              }
              if (!values.role && values.role !== 0) {
                errors.role = "Please select one";
              }
              if (!values.units || values.units.length === 0) {
                errors.units = "Select atleast one";
              }
              if (values.datacenterIds.length === 0) {
                errors.datacenterIds = "Select atleast one";
              }
              return errors;
            }}
            onSubmit={async (values: ITeamRole, { setSubmitting }) => {
              let obj = { ...values };
              if (obj.role === 1) {
                delete obj.datacenterIds
              } else {
                delete obj.datacenterId
              }
              let result;
              handleLoading();
              if (state.shiftManager._id) {
                result = await updateShiftManager(obj);
              } else {
                result = await addShiftManager(obj);
              }
              handleLoading();
              if (result.success) {
                closeAddDialog(result.data);
                //   this.props.toast.show(`Customer ${this.state.customer._id ? "updated" : "created"} successfully`, "success");
              } else {
                showToast(result?.message || `Error while ${state.shiftManager._id ? 'updating' : 'adding'} 'Shift Manager/Operator`, "error")
              }
              setSubmitting(false);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Stack wrap tokens={wrapStackTokens}>
                  <Stack.Item className="custom-textfield">
                    <TextField
                      name="name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.name}
                      label="Name"
                      errorMessage={
                        errors.name && touched.name ? errors.name : ""
                      }
                    />
                  </Stack.Item>
                  <Stack.Item className="custom-textfield">
                    <TextField
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      label="Email"
                      errorMessage={
                        errors.email && touched.email ? errors.email : ""
                      }
                    />
                  </Stack.Item>
                  {state.shiftManager._id === undefined && (
                    <>
                      <Stack.Item className="custom-textfield">
                        <TextField
                          name="password"
                          type="password"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.password}
                          label="Password"
                          errorMessage={
                            errors.password && touched.password
                              ? errors.password
                              : ""
                          }
                        />
                      </Stack.Item>
                      {errors.password && touched.password && values.password && (
                        <Stack.Item>
                          <PasswordPolicy password={values.password} isAdmin={false} />
                        </Stack.Item>
                      )}
                    </>
                  )}
                  <Stack.Item className="custom-dropdown mb-30">
                    <Dropdown
                      options={dropDownOptions}
                      //   selectedKey={data?.role ? data.role : undefined}
                      selectedKey={values.role}
                      label="Select Role"
                      placeholder="Select an option"
                      onChange={(e, item): void => {
                        setFieldValue("role", item?.key);
                        console.log(item?.key);
                      }}
                      disabled={values._id != null}
                      errorMessage={
                        errors.role && touched.role ? errors.role : ""
                      }
                      // styles={dropdownStyles}
                    />
                  </Stack.Item>
                  <Stack.Item className="custom-picker">
                    <Label>Select Infrastructure</Label>
                    <TagPicker
                      defaultSelectedItems={state.defTags}
                      removeButtonAriaLabel="Remove"
                      onResolveSuggestions={filterSuggestedTags as any}
                      getTextFromItem={getTextFromItem}
                      pickerSuggestionsProps={pickerSuggestionsProps}
                      onChange={(items: any) => {
                        console.log("items", items);
                        let units: any = [];
                        items.forEach((element: any) => {
                          units.push(element.key);
                        });
                        setFieldValue("units", units);
                      }}
                      onEmptyResolveSuggestions={showAllTags}
                    />
                    {errors.units && touched.units && (
                        <Text className="error-msg">
                          {errors.units}
                        </Text>
                    )}
                  </Stack.Item>
                  {values.role === 0 && (
                    <Stack.Item className="custom-picker">
                      <Label>Datacenter</Label>
                      <TagPicker
                        removeButtonAriaLabel="Remove"
                        selectedItems={datacenters.filter((d) => values.datacenterIds?.includes(d.key as string))}
                        onResolveSuggestions={filterSuggestedTagsForDC as any}
                        pickerSuggestionsProps={pickerSuggestionsPropsForDC}
                        onEmptyResolveSuggestions={showAllTagsForDC}
                        inputProps={{
                          placeholder: "Search a particular datacenter",
                        }}
                        onChange={(items: any) => {
                          let datacenterIds: string[] = [];
                          items.forEach((i: any) => {
                            datacenterIds.push(i.key);
                          });
                          setFieldValue("datacenterIds", datacenterIds);
                        }}
                      />
                      {errors.datacenterIds && touched.datacenterIds && (
                        <Text className="error-msg">
                          {errors.datacenterIds}
                        </Text>
                      )}
                    </Stack.Item>
                  )}
                  <Stack.Item>
                    <Toggle
                      defaultChecked={values.isEnabled}
                      onText="Enabled"
                      offText="Disabled"
                      onChange={(e, v) => {
                        setFieldValue("isEnabled", v);
                      }}
                    />
                  </Stack.Item>
                </Stack>
                <Stack.Item>
                  <Stack
                    horizontal
                    wrap
                    tokens={wrapStackTokens}
                    horizontalAlign="end"
                  >
                    <DefaultButton
                      text="Cancel"
                      onClick={() => closeAddDialog()}
                      className="borderless-btn"
                    />
                    <PrimaryButton
                      type="submit"
                      text={state.shiftManager._id ? "Update" : "Add"}
                    />
                  </Stack>
                </Stack.Item>
              </form>
            )}
          </Formik>
        </Stack>
      </CustomDrawer>
    </React.Fragment>
  );
};

export default ManageShiftManager;
